<template>
  <ul class="vehicle-list">
    <li v-for="(content, index) in categories" :key="index">
      <video-box :content="content" />
    </li>
  </ul>
</template>

<script>
import VideoBox from '@/components/video-box';

export default {
  name: 'VideoBoxList',
  components: {
    VideoBox,
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
